import _ from 'lodash';

export interface CreateCompanyRecordResponse {
  success: boolean;
  data?;
}

export namespace CreateCompanyRecordResponse {
  export function getCompanyRecordId(createCompanyRecordResponse: CreateCompanyRecordResponse): string | null {
    return _.get(createCompanyRecordResponse, ['data', '0', '_id'], null);
  }
}
